import { GET_PORTFOLIOLOGS } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_PORTFOLIOLOGS:
            return action.payload;
        default:
            return state;
    }
}